const blackListProps = {
  customTheme: true,
  isRecalled: true,
};

export default blackListProps;
